import { Controller } from "@hotwired/stimulus"

// Disables the submit button and shows a spinner while a non-Turbo form POST is in flight
// (e.g. SwissRé report — slow upstream API ; connexion).
export default class extends Controller {
  static targets = ["submit"]
  static values = { message: { type: String, default: "…" } }

  connect() {
    this.restore = this.restore.bind(this)
    // Retour arrière depuis le bfcache : le DOM revient tel quel, bouton figé inclus.
    window.addEventListener("pageshow", this.restore)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.restore)
  }

  disable(event) {
    if (this.element.dataset.submitting === "true") {
      event.preventDefault()
      return
    }

    this.element.dataset.submitting = "true"

    const button = this.submitButton
    if (!button) return

    this.originalContent = Array.from(button.childNodes)

    button.disabled = true
    button.setAttribute("aria-busy", "true")
    button.replaceChildren()

    const spinner = document.createElement("span")
    spinner.className = "spinner-border spinner-border-sm me-2"
    spinner.setAttribute("role", "status")
    spinner.setAttribute("aria-hidden", "true")

    const label = document.createElement("span")
    label.textContent = this.messageValue

    button.append(spinner, label)
  }

  restore(event) {
    if (!event.persisted || this.element.dataset.submitting !== "true") return

    delete this.element.dataset.submitting

    const button = this.submitButton
    if (!button || !this.originalContent) return

    button.disabled = false
    button.removeAttribute("aria-busy")
    button.replaceChildren(...this.originalContent)
  }

  get submitButton() {
    return this.hasSubmitTarget
      ? this.submitTarget
      : this.element.querySelector('[type="submit"]')
  }
}
